<template>
    <div :class="showError ? 'spacing' : ''">
        <VuePhoneNumberInput
            v-model="phone"
            @update="phoneChanged"
            :default-country-code="defaultCountryCode"
            :preferred-countries="['PT', 'IT', 'ES', 'FR']"
            :color="showError ? '#d90b3b' : primaryColor"
            :no-example="true"
            :translations="{
                countrySelectorLabel: $t('strema-country-code-label'),
                countrySelectorError: $t('strema-choose-country-label'),
                phoneNumberLabel: label ? label : $t('strema-phone-label'),
                example: $t('strema-example-label'),
            }"
            :disabled="disabledProp"
        />
        <div v-if="showError" class="phone-error v-text-field__details">
            <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                        {{ phoneError }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import parsePhoneNumberFromString from "libphonenumber-js";

export default {
    components: {
        VuePhoneNumberInput,
    },
    props: {
        label: { type: String },
        value: { type: String },
        disabledProp: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
    },
    data() {
        return {
            phone: "",
            phoneValid: false,
            defaultCountryCallingCode: "+351",
            defaultCountryCode: "",
        };
    },
    methods: {
        inputRequired() {
            return (
                (this.phone == "" ||
                    this.phone == null ||
                    this.phone == undefined) &&
                this.required
            );
        },
        inputInvalid() {
            return (
                this.phone != "" &&
                this.phone != null &&
                this.phone != undefined &&
                !this.phoneValid
            );
        },
        phoneChanged(e) {
            this.phone = e.phoneNumber;
            var fullNumber = "";
            if (e.countryCallingCode) {
                fullNumber = `+${e.countryCallingCode} ${e.phoneNumber}`;
            } else {
                fullNumber = e.phoneNumber;
            }

            this.$emit(
                "input",
                e.phonenumber != "" && e.phoneNumber != undefined
                    ? fullNumber
                    : ""
            );
            this.phoneValid = e.isValid;
            this.$emit("changed", this.phoneValid);
        },
        getCountryCodeFromNumber(val) {
            const result = parsePhoneNumberFromString(val);
            return result && result.country
                ? result.country
                : this.defaultCountryCode;
        },
        removeCountryCode(val) {
            if (val.includes("+")) {
                let splitValue = val.split(" ");
                splitValue.shift();
                val = this.removeCountryCode(splitValue.join(""));
                return val;
            } else {
                return val.trim();
            }
        },
        getCountryCallingCode(val) {
            if (val.includes("+")) {
                val = val.split(" ")[0];
                return val;
            }
            return this.defaultCountryCallingCode;
        },
        checkSpacing(val) {
            if (val.includes("+")) {
                let split = val.split(" ");
                if (split.length <= 1) {
                    let result = parsePhoneNumberFromString(val);
                    if (result.countryCallingCode) {
                        return `+${result.countryCallingCode} ${result.nationalNumber}`;
                    }
                }
            }
            return val;
        },
        setCountryCode(countryCode) {
            this.defaultCountryCode = countryCode.toUpperCase();
        },
    },
    computed: {
        primaryColor() {
            return JSON.parse(localStorage.getItem("@datadrive:domain"))
                .primaryColorHex;
        },
        showError() {
            return this.inputInvalid() || this.inputRequired();
        },
        phoneError() {
            if (this.inputInvalid()) {
                return this.$t("strema-phone-error");
            }
            return this.$t("defaultValidations.required");
        },
    },
    watch: {
        value: {
            handler: function (newValue) {
                if (newValue && !newValue.includes("undefined")) {
                    let result = parsePhoneNumberFromString(newValue);
                    if (
                        result &&
                        result.countryCallingCode &&
                        result.nationalNumber &&
                        result.country
                    ) {
                        this.phone = result.nationalNumber;
                        this.defaultCountryCode = result.country;
                    } else {
                        newValue = this.checkSpacing(newValue);
                        let callingCode = this.getCountryCallingCode(newValue);
                        this.phone = this.removeCountryCode(newValue);
                        this.defaultCountryCode = this.getCountryCodeFromNumber(
                            `${callingCode} ${this.phone}`
                        );
                    }

                    const parsed = parsePhoneNumberFromString(newValue);
                    this.phoneValid = parsed ? parsed.isValid() : false;
                    this.$emit("changed", this.phoneValid);
                } else {
                    this.phone = "";
                    this.phoneValid = false;
                    this.$emit("changed", false);
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        if (!this.defaultCountryCode) {
            this.defaultCountryCode =
                this.$store.getters["auth/getState"].countryCode;
        }
    },
};
</script>

<style lang="scss">
.phone-error {
    position: absolute;
    margin-top: 20px;
    margin-left: 15px;
}
.spacing {
    padding-bottom: 30px;
}

.has-value.is-valid .country-selector__input,
.has-value.is-valid .input-tel__input {
    border-color: rgba(0, 0, 0, 0.42) !important;
}

.has-value.is-valid.is-focused .country-selector__input,
.has-value.is-valid.is-focused .input-tel__input {
    box-shadow: var(--v-primary-base) 0px 0px 0px 0px !important;
    border-bottom-color: var(--v-primary-base) !important;
    border-bottom-width: 2px !important;
}

.has-value.is-focused .input-tel__input,
.has-value.is-focused .country-selector__input {
    box-shadow: var(--v-primary-base) 0px 0px 0px 0px !important;
    border-bottom-width: 2px !important;
}

.is-focused:not(.has-value) .country-selector__input,
.is-focused:not(.has-value) .input-tel__input {
    box-shadow: var(--v-primary-base) 0px 0px 0px 0px !important;
    border-bottom-color: var(--v-primary-base) !important;
    border-bottom-width: 2px !important;
}

.has-value.is-valid.is-focused .country-selector__label,
.has-value.is-valid.is-focused .input-tel__label {
    color: var(--v-primary-base) !important;
}

.has-value.is-valid .country-selector__label,
.has-value.is-valid .input-tel__label {
    color: rgba(0, 0, 0, 0.6) !important;
}

.vue-phone-number-input .input-tel__input {
    height: 57px;
    background: rgba(0, 0, 0, 0.06);
    border: 1px solid #949494;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 4px !important;
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: 0;
}
.vue-phone-number-input .country-selector__input {
    height: 57px;
    background: rgba(0, 0, 0, 0.06);
    border: 1px solid #949494;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 4px !important;
    border-top-width: 0;
    border-left-width: 0;
    border-right-width: 0;
}

.iti-flag {
    margin-top: 10px;
}

.country-selector__list {
    z-index: 500 !important;
}

.v-label {
    z-index: 0 !important;
}
</style>
